import $ from 'jquery';
import 'slick-carousel';

function team_roster() {
	document.addEventListener('DOMContentLoaded', function () {});
}

export default team_roster;
